var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 116,
    viewBox: "0 0 117 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.67664,
    y: 75.4239,
    width: 7.99382,
    height: 7.99382,
    transform: "rotate(-134.027 7.67664 75.4239)",
    stroke: "#E4E4E4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.6766,
    y: 50.4239,
    width: 11.5611,
    height: 11.5611,
    transform: "rotate(-134.027 99.6766 50.4239)",
    stroke: "#E4E4E4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1153,
    y: 81.2257,
    width: 2.93506,
    height: 2.93506,
    transform: "rotate(-134.027 16.1153 81.2257)",
    fill: "#DCF6FF",
    stroke: "#DCF6FF",
    strokeWidth: 2.93506
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.1153,
    y: 6.22568,
    width: 2.93506,
    height: 2.93506,
    transform: "rotate(-134.027 79.1153 6.22568)",
    fill: "#DCF6FF",
    stroke: "#DCF6FF",
    strokeWidth: 2.93506
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9929 67.9858C58.2998 67.9858 70.7085 55.5771 70.7085 40.2702C70.7085 24.9634 58.2998 12.5547 42.9929 12.5547C27.686 12.5547 15.2773 24.9634 15.2773 40.2702C15.2773 55.5771 27.686 67.9858 42.9929 67.9858Z",
    fill: "#DCF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7079 57.176L61.1396 62.3269L66.2905 67.8952L71.8588 62.7443L66.7079 57.176Z",
    fill: "white",
    stroke: "#E4E4E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5349 65.4412C75.3466 63.0756 71.655 62.9318 69.2894 65.1201C66.9238 67.3083 66.78 71 68.9683 73.3656L103.681 110.891C105.869 113.257 109.561 113.401 111.927 111.212C114.292 109.024 114.436 105.333 112.248 102.967L77.5349 65.4412Z",
    fill: "white",
    stroke: "#E4E4E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7845 37.8662C49.8286 37.8662 50.675 37.0198 50.675 35.9757C50.675 34.9316 49.8286 34.0852 48.7845 34.0852C47.7404 34.0852 46.894 34.9316 46.894 35.9757C46.894 37.0198 47.7404 37.8662 48.7845 37.8662Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3636 42.3293C34.4077 42.3293 35.2541 41.4829 35.2541 40.4388C35.2541 39.3947 34.4077 38.5483 33.3636 38.5483C32.3195 38.5483 31.4731 39.3947 31.4731 40.4388C31.4731 41.4829 32.3195 42.3293 33.3636 42.3293Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3176 49.5294C45.2511 49.5294 46.8185 47.962 46.8185 46.0285C46.8185 44.095 45.2511 42.5276 43.3176 42.5276C41.3841 42.5276 39.8167 44.095 39.8167 46.0285C39.8167 47.962 41.3841 49.5294 43.3176 49.5294Z",
    fill: "white",
    stroke: "#E4E4E4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7246 22.0707C36.569 22.1062 36.406 22.0875 36.2625 22.0177C36.119 21.9478 36.0036 21.8311 35.9356 21.6868C35.8675 21.5424 35.8508 21.3792 35.8881 21.224C35.9255 21.0689 36.0148 20.9312 36.1411 20.8337C39.2134 18.4298 42.9905 17.102 46.8912 17.0545C50.7919 17.0071 54.6002 18.2427 57.7301 20.5711C57.8569 20.6641 57.9485 20.7974 57.9897 20.9491C58.031 21.1009 58.0195 21.2622 57.9571 21.4065C57.8947 21.5509 57.7852 21.6698 57.6464 21.7439C57.5077 21.8179 57.3479 21.8426 57.1933 21.814L46.9764 19.9876C46.8878 19.9702 46.7966 19.9702 46.708 19.9876L36.7246 22.0707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9337 66.4874C74.4632 65.9788 73.6695 65.9479 73.1609 66.4184C72.6523 66.8889 72.6214 67.6826 73.0919 68.1912L108.474 106.441C108.945 106.949 109.738 106.98 110.247 106.51C110.756 106.039 110.787 105.246 110.316 104.737L74.9337 66.4874Z",
    fill: "#DCF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.216 67.2273C59.5229 67.2273 71.9316 54.8186 71.9316 39.5117C71.9316 24.2048 59.5229 11.7961 44.216 11.7961C28.9092 11.7961 16.5005 24.2048 16.5005 39.5117C16.5005 54.8186 28.9092 67.2273 44.216 67.2273Z",
    stroke: "#B9B9B9",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1257 70.2514C61.316 70.2514 75.2514 56.316 75.2514 39.1257C75.2514 21.9355 61.316 8 44.1257 8C26.9355 8 13 21.9355 13 39.1257C13 56.316 26.9355 70.2514 44.1257 70.2514Z",
    stroke: "#B9B9B9",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116.21,
    height: 115.175,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no_results.352a462f83715ab293f28d844f925c27.svg";
export { ForwardRef as ReactComponent };